import { Injectable } from '@angular/core';
import { UrlSignature } from '../common/apiEndPoint';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Portfolio } from './portfolio';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class PortfolioService {
  constructor(private httpClient: HttpClient, private urlSignature: UrlSignature) {}

  getPortfolioList(personId: string): Observable<Portfolio[]> {
    const url = this.urlSignature.portfolioListUrl + '/' + personId;
    return this.httpClient.get(url).pipe(map((response) => response as Portfolio[]));
  }

  savePortfolioDetails(portfolioList: Portfolio[]): Observable<Response> {
    const url = this.urlSignature.portfolioListUrl;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    let data = JSON.stringify(portfolioList);
    return this.httpClient.post(url, data, httpOptions).pipe(map((response) => response as Response));
  }

  deletePortfolio(portfolioId: string) {
    const url = this.urlSignature.portfolioListUrl + '/' + portfolioId;
    this.httpClient.delete(url).subscribe((response) => {
      console.log(response);
    });
  }
}
